import {
  imageModifierTypes,
  IMAGE_DOMAIN_BASE_URL,
  ONMAP_IMAGES_MODIFIERS_MAP
} from '../constants';
import { setImageModifier } from './onmapImageModifiers';
import thumbnailPic from '../../static/images/images_placeholder.svg';

export const formatSrcSetUrl = (imageUrl) => (
  imageUrl ? imageUrl.replace(/\s/g, '%20').replace(/,/g, '%2C') : imageUrl
);

export const formatImageSrcSet = candidates => candidates
  .map(({ imageUrl, width }) => `${formatSrcSetUrl(imageUrl)} ${width}w`)
  .join(', ');

const modifyImageLink = (imageLink, type = imageModifierTypes.THUMBNAIL) => {
  if (!imageLink || typeof imageLink !== 'string') {
    return '';
  }

  if (imageLink.startsWith(IMAGE_DOMAIN_BASE_URL)) {
    const onmapImageModifier = ONMAP_IMAGES_MODIFIERS_MAP[type];
    return formatSrcSetUrl(setImageModifier(imageLink, onmapImageModifier));
  }

  return imageLink;
};

export const formatErrorImage = (imgUrl = '', placeholderImage = thumbnailPic) => {
  if (imgUrl.startsWith(IMAGE_DOMAIN_BASE_URL)) {
    return modifyImageLink(imgUrl, imageModifierTypes.NOT_MODIFIED);
  }

  return placeholderImage;
};

export default modifyImageLink;
